<template>
  <div>
    <span style="width: 100%; height: 100%" @click="OpenDialog">
      <span class="userinfo" type="info">个人资料</span>
    </span>

    <el-dialog
      title="账户信息"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      @close="closeUserinfo"
    >
      <el-form size="mini" ref="form" :model="form" :rules="rules">
        <el-form-item label="真实姓名" required>
          <el-input
            disabled
            placeholder="请输入真实姓名"
            v-model="form.realname"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="账号" required>
          <el-input disabled placeholder="请输入账号" v-model="form.name">
          </el-input>
        </el-form-item>

        <el-form-item label="昵称">
          <el-input placeholder="请输入昵称" v-model="form.nickname">
          </el-input>
        </el-form-item>

        <el-form-item label="头像" required prop="fileList">
          <el-upload
            action=""
            :http-request="uploadFile"
            :on-remove="handleRemove"
            :on-change="handleChangeFile"
            :auto-upload="false"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="form.fileList"
            list-type="picture"
          >
            <el-button size="mini" type="primary" plain>点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item v-if="$store.state.user.identity !== 2" label="微信名片">
          <el-upload
            action=""
            :http-request="uploadFile"
            :on-remove="handleRemove1"
            :on-change="handleChangeFile1"
            :auto-upload="false"
            :limit="1"
            :on-exceed="handleExceed1"
            :file-list="form.fileList1"
            list-type="picture"
          >
            <el-button size="mini" type="primary" plain>点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit('form')" size="small"
          >保存</el-button
        >
        <el-button @click="quitDialog('form')" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { deleteImages } from '@/api/homeset'
import uploadFile from '@/config/uploadFile'

import { tchUpdateTchInfo, stuUpdateStudentInfo } from '@/api/educational'
import { api_stuOrderUpdateHeadState } from '@/api/javaApi'

export default {
  name: 'userinfo',
  props: {
    homepageBanner: Array,
    homepage_id: Number,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请上传图片'))
      } else {
        callback()
      }
    }
    return {
      imageId: '',
      form: {
        realname: '',
        nickname: '',
        name: '',
        fileList: [],
        fileList1: [],
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        title_one: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 4, max: 8, message: '长度在 4 到 8 个字符', trigger: 'blur' },
        ],
        title_two: [{ required: true, message: '请输入口号', trigger: 'blur' }],
        content: [
          { required: true, message: '请填写内容介绍', trigger: 'blur' },
        ],
        fileList: [{ validator: validatePass, trigger: 'change' }],
      },
      uploadFileTime: false,
    }
  },
  watch: {
    homepageBanner() {
      this.tableData = this.homepageBanner
    },
  },
  methods: {
    addImage() {
      this.form.title_one = ''
      this.form.title_two = ''
      this.form.fileList = []
      this.form.content = ''
      this.imageId = ''
      this.dialogVisible = true
    },

    OpenDialog() {
      console.log('打开账户信息')

      if (this.$store.state.user.identity === 2) {
        console.log('学生信息')
        this.form.realname = this.$store.state.user.userInfo.stuUserInfo.realName
        this.form.nickname = this.$store.state.user.userInfo.stuUserInfo.nickname
        this.form.name = this.$store.state.user.userInfo.name

        if (this.$store.state.user.userInfo.headimgUrl) {
          this.form.fileList = [
            {
              url: this.$store.state.user.userInfo.headimgUrl,
              name: this.$store.state.user.userInfo.headimgUrl.split('/')[
                this.$store.state.user.userInfo.headimgUrl.split('/').length - 1
              ],
            },
          ]
        }
      } else {
        console.log('老师信息')
        this.form.realname = this.$store.state.user.userInfo.realName
        this.form.nickname = this.$store.state.user.userInfo.nickname
        this.form.name = this.$store.state.user.userInfo.name

        if (this.$store.state.user.userInfo.userImageUrl) {
          this.form.fileList = [
            {
              url: this.$store.state.user.userInfo.userImageUrl,
              name: this.$store.state.user.userInfo.userImageUrl.split('/')[
                this.$store.state.user.userInfo.userImageUrl.split('/').length -
                  1
              ],
            },
          ]
        }
        if (this.$store.state.user.userInfo.cardImgUrl) {
          this.form.fileList1 = [
            {
              url: this.$store.state.user.userInfo.cardImgUrl,
              name: this.$store.state.user.userInfo.cardImgUrl.split('/')[
                this.$store.state.user.userInfo.cardImgUrl.split('/').length - 1
              ],
            },
          ]
        }
      }

      this.dialogVisible = true
    },

    closeUserinfo() {
      console.log('关闭用户信息')
      this.dialogVisible = false
    },

    quitDialog(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    },
    updateImages(row) {
      this.imageId = row.id
      this.form.title_one = row.title_one
      this.form.title_two = row.title_two
      this.form.content = row.content
      this.form.fileList = [
        {
          url: row.img_url,
          name: row.img_url.split('/')[row.img_url.split('/').length - 1],
        },
      ]
      this.dialogVisible = true
    },

    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$store.state.user.identity === 2) {
            console.log('更新学生账号信息')

            stuUpdateStudentInfo({
              nickname: this.form.nickname,
              headimg_url: this.form.fileList[0].url,
            }).then(() => {
              this.$message.success('修改成功')
              this.dialogVisible = false
              this.freshData()
              if (
                this.form.fileList[0].url !==
                this.$store.state.user.userInfo.headimgUrl
              ) {
                // 头像已更改
                api_stuOrderUpdateHeadState()
              }
            })
          } else {
            console.log('更新老师账号信息')
            tchUpdateTchInfo({
              nickname: this.form.nickname,
              headimg_url: this.form.fileList[0].url,
              card_img_url: this.form.fileList1[0]
                ? this.form.fileList1[0].url
                : '',
            }).then(() => {
              this.$message.success('修改成功')
              this.dialogVisible = false
              this.freshData()
            })
          }
        }
      })
    },
    //刷新账号信息
    freshData() {
      this.$store.dispatch('freshUserData')
    },
    uploadFile() {},
    handleRemove(file, fileList) {
      this.form.fileList = fileList
    },

    handleRemove1(file, fileList) {
      this.form.fileList1 = fileList
    },

    handleExceed() {
      this.$message.warning(`只能上传1张图片，请删除后重新上传！`)
    },
    handleExceed1() {
      this.$message.warning(`只能上传1张图片，请删除后重新上传！`)
    },

    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },

    async handleChangeFile1(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss1(fileList)
      }
    },

    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.form.fileList = res
          this.uploadFileTime = false
        }
      )
    },

    async uploadFileOss1(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.form.fileList1 = res
          this.uploadFileTime = false
        }
      )
    },

    deleteImage(row) {
      this.$confirm('确定删除本条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteImages({
          id: row.id,
        }).then((res) => {
          if (res.is_delete) {
            this.$message.success('删除成功！')

            for (var i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].id === row.id) {
                this.tableData.splice(i, 1)
              }
            }
          }
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.userinfo {
  color: #606166;
}

.userinfo:hover {
  color: #67b1ff;
}
</style>
